import type { ServerColDef } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

const coveredAccountsColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'coveredAccountsCount',
  headerName: 'Covered Accounts',
  type: ['numericColumn', 'number'],
  filter: 'agNumberColumnFilter',
  minWidth: 160,
};

export default coveredAccountsColDef;
